<template>
  <div class="min-h-screen">
    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 theme-header flex items-center">
        <a @click="$router.back()" class="text-gray-600 hover:text-blue-500 transition-colors">
          <!-- <font-awesome-icon icon="arrow-left" class="text-xl" /> -->
        </a>
        <div class="flex-1 flex items-center justify-center space-x-2">
          <div class="relative w-6 h-6">
            <div class="absolute inset-0 theme-bg-primary rounded-full opacity-20 animate-ping"></div>
            <div class="relative w-6 h-6 theme-bg-primary rounded-full flex items-center justify-center">
              <!-- <font-awesome-icon icon="robot" class="text-white text-sm" /> -->
              <img style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi2.png"/>
            </div>
          </div>
          <h1 class="text-lg font-semibold text-gray-800">AI问诊</h1>
        </div>
        <router-link to="/hospitals" class="text-gray-600 hover:text-blue-500 transition-colors relative group hospital-link">
          <div class="relative hospitalBox">
            <!-- <font-awesome-icon icon="hospital" class="text-xl" /> -->
            <div class="hospital-badge">附近</div>
          </div>
          <div class="absolute -bottom-12 right-0 bg-gray-800 text-white text-xs px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50 flex items-center space-x-1">
            <!-- <font-awesome-icon icon="map-marker-alt" class="text-blue-400" /> -->
            <span>查看附近医院列表</span>
          </div>
        </router-link>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="chat-container">
      <!-- 消息列表 -->
      <div ref="chatContainer" class="message-list p-4 space-y-6">
        <!-- AI欢迎消息 -->
        <!-- <div class="flex items-start space-x-4">
          <div class="ai-avatar flex-shrink-0">
            <font-awesome-icon icon="robot" class="text-white text-lg" />
          </div>
          <div class="message-bubble ai bg-white rounded-2xl p-4 shadow-sm max-w-[80%]">
            <div class="text-gray-800 leading-relaxed" style="text-align: left;" v-html="aiResult"></div>
          </div>
        </div> -->

        <!-- 医院入口提示 -->
        <div class="flex items-start space-x-4">
          <div class="ai-avatar flex-shrink-0">
            <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi2.png"/>
            <!-- <font-awesome-icon icon="robot" class="text-white text-lg" /> -->
          </div>
          <div class="message-bubble ai bg-white rounded-2xl p-4 shadow-sm max-w-[80%]">
            <p class="text-gray-800 mb-3">如果需要实体医院就诊，您可以：</p>
            <router-link to="/hospitals" class="group flex items-center space-x-3 theme-bg-gradient text-white px-4 py-2.5 rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all shadow-sm">
              <!-- <font-awesome-icon icon="hospital" /> -->
              <img style="width: 16px;height: 16px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/hospital.png"/>
              <span class="flex-1">查看附近医院</span>
              <!-- <font-awesome-icon icon="chevron-right" class="text-sm opacity-50 group-hover:opacity-100 transition-opacity transform group-hover:translate-x-1" /> -->
              <img style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right3.png"/>
            </router-link>
          </div>
        </div>
        <!-- 消息列表 -->

        <div
          v-for="(message, index) in messages"
          :key="index"
        >
          <!-- 用户消息 -->
          <div v-if="message.type === 'user'" class="flex items-start space-x-4 justify-end">
            <div class="message-bubble user theme-bg-gradient rounded-2xl p-4 shadow-sm max-w-[80%]">
              <!-- 文本消息 -->
              <p class="text-white">{{ message.content }}</p>
            </div>
            <div class="w-10 h-10 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm border-2 border-white">
              <!-- <font-awesome-icon icon="user" class="text-gray-500" /> -->
              <img style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/user.png"/>
            </div>
          </div>
          <!-- AI消息 -->
          <div v-else class="flex items-start space-x-4">
            <div class="ai-avatar flex-shrink-0">
              <!-- <font-awesome-icon icon="robot" class="text-white text-lg" /> -->
              <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi2.png"/>
            </div>
            <div class="message-bubble ai bg-white rounded-2xl p-4 shadow-sm max-w-[80%]">
              <!-- 文本消息 -->
              <div v-if="message.content &&message.contentType === 'text'" class="text-gray-800 leading-relaxed" style="text-align: left;" v-html="message.content"></div>
              <div v-if="!message.content" class="flex items-start space-x-4">
                <div class="message-bubble ai bg-white rounded-2xl p-4 shadow-sm">
                  <div class="typing-indicator">
                    <div class="typing-dot"></div>
                    <div class="typing-dot"></div>
                    <div class="typing-dot"></div>
                  </div>
                </div>
              </div>
              <!-- 问题列表 -->
              <!-- <div v-else-if="message.contentType === 'questions'" class="space-y-2.5 ml-1">
                <div v-for="(question, qIndex) in message.content" :key="qIndex" class="flex items-start space-x-3">
                  <span class="flex-shrink-0 w-5 h-5 rounded-full theme-bg-light text-blue-500 flex items-center justify-center text-xs font-medium">{{ qIndex + 1 }}</span>
                  <p class="text-gray-700">{{ question }}</p>
                </div>
              </div> -->
              
              <!-- 建议卡片 -->
              <!-- <div v-else-if="message.contentType === 'suggestion'" class="space-y-3">
                <h4 class="font-medium">{{ message.content.title }}</h4>
                <p class="text-gray-700">{{ message.content.description }}</p>
                <div class="flex justify-between text-sm">
                  <span class="theme-text-primary">建议等级：{{ message.content.level }}</span>
                  <span class="text-gray-500">置信度：{{ message.content.confidence }}%</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 快速回复选项 -->
        <!-- <div v-if="quickReplies.length > 0" class="flex flex-wrap gap-2 mt-4">
          <button 
            v-for="(reply, index) in quickReplies" 
            :key="index"
            class="quick-reply-btn bg-white theme-text-primary px-4 py-2 rounded-xl text-sm hover:bg-blue-50 shadow-sm border theme-border-light flex items-center space-x-2"
            @click="useQuickReply(reply.text)"
          >
            <font-awesome-icon :icon="reply.icon" class="theme-text-light text-xs" />
            <span>{{ reply.text }}</span>
          </button>
        </div> -->

        <!-- 正在输入提示 -->
        <!-- <div v-if="loading" class="flex items-start space-x-4">
          <div class="ai-avatar flex-shrink-0">
            <font-awesome-icon icon="robot" class="text-white text-lg" />
          </div>
          <div class="message-bubble ai bg-white rounded-2xl p-4 shadow-sm">
            <div class="typing-indicator">
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- 输入框 -->
      <div class="fixed bottom-0 left-0 right-0 input-container border-t border-gray-100 bg-white">
        <div class="flex items-center space-x-3 max-w-4xl mx-auto py-3 px-4">
          <div class="flex-1">
            <input 
              v-model="inputMessage"
              type="text" 
              placeholder="请输入您的问题..." 
              class="message-input w-full bg-gray-50 rounded-xl px-4 py-2.5 focus:outline-none focus:bg-white text-gray-700 text-sm"
              :disabled="loading"
              @keypress.enter.prevent="sendMessage"
            >
          </div>
          <button 
            class="send-btn theme-bg-gradient text-white p-2.5 rounded-xl w-11 h-11 flex items-center justify-center hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5"
            :disabled="!inputMessage || loading"
            @click="sendMessage"
          >
          <img v-if="loading" class="loadingAni" style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/spinner.png"/>
          <img v-else style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paper-plane.png"/>
            <!-- <font-awesome-icon :icon="loading ? 'spinner' : 'paper-plane'" :spin="loading" /> -->
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ThemeManager } from '@/utils'
import { RPC } from '@/api/rpc'

export default {
  name: 'AIDiagnosis',
  data() {
    return {
      messages: [],
      inputMessage: '',
      loading: false,
      sessionId: null,
      quickReplies: [],
      currentTheme: 'neutral',
      aiResult: ''
    }
  },
  async mounted() {
    // 从本地存储加载主题设置
    const savedTheme = ThemeManager.getCurrentTheme();
    if (savedTheme) {
      this.currentTheme = savedTheme;
    }
    this.aiConnectFun()
    // 添加主题变更监听器
    ThemeManager.addThemeChangeListener(this.handleThemeChange);
  },
  beforeDestroy() {
    RPC.disconnect().then(res=>{
      console.log('关闭AI连接',res)
    })
    // 移除主题变更监听器
    ThemeManager.removeThemeChangeListener(this.handleThemeChange);
  },
  methods: {
    async aiConnectFun() {
      this.aiResult = ''
      const token = localStorage.getItem('token') || ''
      const response = await fetch('https://www.airpets.cn'+'/ops/ai/connect', {
        method: 'GET',
        headers: {
          'token': token, // 认证 token
        }
      })
      
      this.messages.push({
        type: 'ai',
        typeS: 'aiFirst',
        contentStatus: true,
        contentType: 'text',
        content: '',
        timestamp: Date.now()
      })
      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          console.log('数据流结束');
          break;
        }
        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split('\n');
        let message = '';
        for (const line of lines) {
          if(line != ''){
            const jsonStr = line.replace(/^data:\s*/, '').trim();
            if (jsonStr == '[DONE]'){
              this.loading = false
              break
            } 
            try {
              this.aiResult +=  jsonStr.replace(/\\n/g, '<br>'); // 实时拼接响应内容
              this.messages.map((item,index)=>{
                if(item.typeS === 'aiFirst' && item.contentStatus){
                  item.content = this.aiResult
                }
                if(item.type === 'ai' && item.contentStatus){
                  item.content = this.aiResult
                }
              })
            } catch (e) {
              console.error('解析出错：', e);
            }
          }
        }
        this.scrollToBottom()
    
      }
    },
    async sendMessage() {
      if (!this.inputMessage || this.loading) return
      this.messages.map(item=>{
        item.contentStatus = false
      })
      const message = {
        type: 'user',
        contentType: 'text',
        contentStatus: false,
        content: this.inputMessage,
        timestamp: Date.now()
      }

      this.messages.push(message)
      
      this.messages.push({
        type: 'ai',
        contentType: 'text',
        contentStatus: true,
        content: '',
        timestamp: Date.now()
      })
      this.inputMessage = ''
      this.quickReplies = []
      this.scrollToBottom()
      this.loading = true
      this.aiResult = ''
      RPC.aiSend({
        'askString': message.content
      }).then(res=>{
        console.log('2345',res)
      })
    },
    
    useQuickReply(text) {
      this.inputMessage = text
      this.sendMessage()
    },
    
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        container.scrollTop = container.scrollHeight
      })
    },
    
    async initSession() {
      this.sessionId = 'mock-session-' + Date.now()
    },
    
    handleThemeChange(theme) {
      this.currentTheme = theme;
    }
  },
  async created() {
    await this.initSession()
  }
}
</script>

<style scoped>
.chat-container {
  height: 100vh;
  padding-top: 64px;
  padding-bottom: 76px;
  background: linear-gradient(180deg, var(--background-color) 0%, #F3F4F6 100%);
  display: flex;
  flex-direction: column;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.message-list::-webkit-scrollbar {
  width: 6px;
}

.message-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.message-list::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.message-list::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}

.quick-reply-btn {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.quick-reply-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.2) 50%,
    rgba(255,255,255,0) 100%
  );
  transition: left 0.5s ease;
}

.quick-reply-btn:hover::before {
  left: 100%;
}

.quick-reply-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--primary-color-rgb), 0.15);
}

.send-btn {
  transition: all 0.3s ease;
}

.send-btn:hover {
  transform: scale(1.05);
}

.ai-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(var(--primary-color-rgb), 0.2);
}

.ai-avatar::after {
  content: '🤖';
  position: absolute;
  bottom: -4px;
  right: -4px;
  font-size: 14px;
  background: white;
  border-radius: 50%;
  padding: 3px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.message-bubble {
  position: relative;
  transition: all 0.3s ease;
}

.message-bubble:hover {
  transform: translateY(-1px);
}

.message-bubble.ai::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 12px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #fff;
}

.message-bubble.user::before {
  content: '';
  position: absolute;
  right: -8px;
  top: 12px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid var(--primary-color);
}

.typing-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.typing-dot {
  width: 4px;
  height: 4px;
  background-color: var(--primary-light);
  border-radius: 50%;
  animation: typing 1.4s infinite;
}

.typing-dot:nth-child(2) { animation-delay: 0.2s; }
.typing-dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

.input-container {
  background: linear-gradient(180deg, rgba(255,255,255,0.9) 0%, #FFFFFF 100%);
  backdrop-filter: blur(12px);
}

.message-input {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.message-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(var(--primary-color-rgb), 0.1);
}

.hospital-link {
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-right: -8px;
}
.hospitalBox {
  /* display: flex;
  align-items: center;
  justify-content: center;
  position: relative; */
}
.hospital-badge {
  /* position: absolute;
  top: -6px;
  right: -6px; */
  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));
  color: white;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1.5px solid white;
  animation: pulse 2s infinite;
  width: 100%;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.hospital-link:active {
  transform: scale(0.95);
}

.hospital-link::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: rgba(var(--primary-color-rgb), 0.1);
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}

.hospital-link:hover::before {
  opacity: 1;
  transform: scale(1);
}

.hospital-link:hover {
  box-shadow: 0 4px 12px rgba(var(--primary-color-rgb), 0.2);
}

/* 添加主题相关的类 */
.theme-header {
  background: var(--gradient-header);
}

.theme-bg-primary {
  background-color: var(--primary-color);
}

.theme-bg-light {
  background-color: var(--secondary-color);
}

.theme-text-primary {
  color: var(--primary-color);
}

.theme-text-light {
  color: var(--primary-light);
}

.theme-border-light {
  border-color: var(--secondary-color);
}

.theme-bg-gradient {
  background: linear-gradient(to right, var(--primary-color), var(--accent-color));
}
.loadingAni {
  animation: rotate 2s linear infinite; /* 2秒一圈，无限循环 */
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style> 